import {
  Component,
  EventEmitter,
  inject,
  OnInit,
  Output,
  signal,
  ViewChild,
} from '@angular/core';
import { AddMenuItemRequest } from '../../models/add-menuItem-request/add-menuItem-request.model';
import { MenuItemsServiceService } from '../../Services/menu-items.service.service';
import { NotificationService } from '../../Services/notification.service';
import { CategoryService } from '../../Services/category.service';
import { UpdateItemImage } from '../../models/add-menuItem-request/update-item-image.model';
import { UploadImageComponent } from '../../adminComponents/upload-image/upload-image.component';
import { DropdownAdminComponent } from '../../adminComponents/dropdown-admin/dropdown-admin.component';

@Component({
  selector: 'app-page-add-item',
  templateUrl: './page-add-item.component.html',
  styleUrl: './page-add-item.component.scss',
})
export class PageAddItemComponent implements OnInit {
  @ViewChild(UploadImageComponent) uploadImageComponent!: UploadImageComponent;
  @ViewChild(DropdownAdminComponent)
  dropDownAdminComponent!: DropdownAdminComponent;

  model: AddMenuItemRequest;
  categories: { nameEn: string; id: number }[] = [];

  private menuItemsService = inject(MenuItemsServiceService);
  private categoryService = inject(CategoryService);
  private notificationService = inject(NotificationService);

  @Output() show = new EventEmitter<boolean>(true);
  @Output() ID = new EventEmitter<number>();
  imageModel: UpdateItemImage = { id: 0, image: undefined };
  resetDropdown: boolean = false;

  imgName?: string;
  CategoriesTitle = signal<string>('Select Category');

  constructor() {
    this.model = {
      NameAr: '',
      NameEn: '',
      NameTr: '',
      DescriptionAr: '',
      DescriptionTr: '',
      DescriptionEn: '',
      PriceAr: '',
      PriceEn: '',
      PriceTr: '',
      imageUrl: null,
      categoryId: '0',
    };
  }
  ngOnInit(): void {
    this.loadCategories();
  }
  imge!: File;
  onFormSubmit() {
    if (
      this.model.NameAr != '' &&
      this.model.NameEn != '' &&
      this.model.NameTr != '' &&
      this.model.PriceTr != '' &&
      this.model.PriceEn != '' &&
      this.model.PriceAr != '' &&
      this.model.categoryId != '0'
    ) {
      this.menuItemsService.addMenuItem(this.model).subscribe({
        
        next: (response) => {
          //console.log('Category added successfully:', response);
          this.showSuccessMessage();
          this.resetDropdown = true;
          this.uploadImageComponent.resetImage();
          this.dropDownAdminComponent.ngOnChanges();
          this.clearModel();
        },
        error: (err) => {
          this.showErrorMessage();
          //console.error('Error occurred while adding category:', err);
          if (err.error) {
            //console.error('Error details:', err.error);
          }
        },
      });

      
    } else {
      this.MessageRequiredField();
    }
  }

  loadCategories() {
    this.categoryService.getAllCategories().subscribe({
      next: (data) => {
        //console.log(data); // Log the whole data to see its structure
        this.categories = data.map((category) => ({
          nameEn: category.nameEn, // Adjust 'name' to the actual property name for category names
          id: category.id, // Adjust 'id' to the actual property name for category IDs
        }));
        //console.log('categories En', this.categories); // Log the whole data to see its structure
      },
      error: (err) => {
        this.showErrorMessage();
        //console.error('Error occurred while fetching categories:', err);
        if (err.error) {
          //console.error('Error details:', err.error);
        }
      },
    });
  }

  Maximize() {
    this.show.emit();
  }

  onSelectedImage(img: File) {
    this.model.imageUrl = img;
    this.imgName = img.name;

    //console.log('selected image', img);
  }

  onCategorySelect(id: number) {
    this.model.categoryId = id.toString();
    //console.log('category id', this.model.categoryId);
  }

  onFileSelected(event: any) {
    this.model.imageUrl = event.target.files[0];
    //console.log('Selected image:', this.model.imageUrl);
  }
  showErrorMessage() {
    this.notificationService.showMessage('Failed To Add Item', 'danger');
  }

  ErrorMessage() {
    this.notificationService.showMessage('Failed Loading Data', 'danger');
  }
  showSuccessMessage() {
    this.notificationService.showMessage('Successfully Item Added', 'success');
  }

  MessageRequiredField() {
    this.notificationService.showMessage('Required Field is Empty', 'danger');
  }

  clearModel() {
    this.model = {
      NameAr: '',
      NameEn: '',
      NameTr: '',
      DescriptionAr: '',
      DescriptionTr: '',
      DescriptionEn: '',
      PriceAr: '',
      PriceEn: '',
      PriceTr: '',
      imageUrl: null,
      categoryId: '0',
    };
    this.CategoriesTitle.set('Select Category'); // Change the title after submit
    this.imgName = undefined; // Reset the image name
    this.model.imageUrl = null; // Reset the image URL
    this.count = 0;
    this.countIndirim = 0;
  }
  count = 0;
  countIndirim = 0;
  onPriceChange(language: string, value: string) {
    // Update the other fields when any price field changes
    if(this.count < 3){
      if (language === 'Tr') {
        this.model.PriceEn = value; // Set PriceTr to the new value of PriceEn
        this.model.PriceAr = value; // Set PriceAr to the new value of PriceEn
        this.count++;
      } else if (language === 'En') {
        this.model.PriceEn = value; // Set PriceEn to the new value of PriceTr
      } else if (language === 'AR') {
        this.model.PriceAr = value; // Set PriceEn to the new value of PriceAr
      }
    }

  }
}

